(function () {
  function initSection(section) {
    if (section.getAttribute('data-reveal-ready') === 'true') return;
    section.setAttribute('data-reveal-ready', 'true');

    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reducedMotion || !('IntersectionObserver' in window)) {
      section.classList.add('is-visible');
      return;
    }

    // Opt in to the hidden-until-revealed CSS only now that we know JS is
    // actually running and about to observe the section.
    section.classList.add('product-showcase--reveal');

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            section.classList.add('is-visible');
            observer.unobserve(section);
          }
        });
      },
      { threshold: 0.2 }
    );

    observer.observe(section);
  }

  function initAll() {
    var sections = document.querySelectorAll('.product-showcase');
    for (var i = 0; i < sections.length; i++) {
      initSection(sections[i]);
    }
  }

  initAll();
  document.addEventListener('DOMContentLoaded', initAll);
  window.addEventListener('load', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();
